import React, { useEffect, useState } from "react";
import styles from './StoreInventory.module.css';
import { AntdDropdown, AntdSubmit } from "../../components";
import { List } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import AlertAction from "../../store/Actions/AlertActions";
import { useDispatch, useSelector } from "react-redux";
import StoreMiddleware from "../../store/Middlewares/StoreMiddleware";
import { BiMinus, BiPlus } from "react-icons/bi";
// import { useNavigate } from "react-router";
const StoreInventory = () => {

  const { state } = useLocation()
  const previousData = state;

  console.log('previousData', previousData)

  useEffect(() => {
    getInventory();
  }, []);

  const dispatch = useDispatch();
  const user = useSelector(state => state.AuthReducer.user);
  const [Refresh, setRefresh] = useState(false);
  const [Inventory, setInventory] = useState([]);
  const [selectedLocation, setselectedLocation] = useState(null);
  // const data = props?.route?.params?.data;
  console.log('Inventory', Inventory)

  const getInventory = () => {
    dispatch(StoreMiddleware.getInventory())
      .then(data => {
        setInventory(data?.data);
      })
      .catch(err => console.log(err));
  };

  const onPressIncreaseQuantity = index => {
    // console.log('Inventory[index].quantity',Inventory[index].quantity)
    Inventory[index].quantity = Inventory[index].quantity + 1;
    setRefresh(!Refresh);
  };

  const onPressDecreaseQuantity = index => {
    if (Inventory[index].quantity == 0) {
    } else {
      Inventory[index].quantity = Inventory[index].quantity - 1;
      setRefresh(!Refresh);
    }
  };

  const onPressDone = () => {
    if (!selectedLocation) {
      dispatch(AlertAction.ShowAlert({ type: "error", message: 'Select store location' }))
    }
    else {
      const inventorydata = []
      for (let i = 0; i < Inventory.length; i++) {
        if (Inventory[i].quantity > 0) {
          inventorydata.push(Inventory[i])
        }
      }
      if (previousData?.screenName == 'workOrderForm') {
        navigate("/WorkOrderRequestForm", {
          state: {
            data: { storeid: previousData?.data?.id, Locationid: selectedLocation, inventory: inventorydata },
            screenName: 'workOrderForm',
            current: 0,
          }
        })
        // previousData?.getData({ storeid: data?.id, Locationid: selectedLocation, inventory: inventorydata });
        // navigation.navigate('WorkOrderRequestForm');
      }
      // else if(previousData?.screenName == 'Editjobdetail'){
      //   previousData?.getData({ storeid: data?.id, Locationid: selectedLocation, inventory: inventorydata });
      //   // navigation.navigate('EditJobDetails');
      // }
      // else {
      //   previousData?.getData({ storeid: data?.id, Locationid: selectedLocation, inventory: inventorydata });
      //   // navigation.navigate('AddJobDetails');

      // }
    }
  }

  const navigate = useNavigate();
  const renderItem = (item, index) => {
    return (
      <div className={styles.listitemRow}>
        <div className={styles.ColLeft}>
          <p>{item?.name}</p>
        </div>
        <div className={styles.ColRight}>
          <button onClick={() => onPressDecreaseQuantity(index)} className={styles.button}><BiMinus color="white" style={{width:'15px'}} /></button>
          <div className={styles.usedDiv}>
            <input
              value={item?.quantity ? item?.quantity : '0'}
            // onChange={(e) => setUsedItem(e.target.value)}
            />
          </div>
          <button onClick={() => onPressIncreaseQuantity(index)} className={styles.button}><BiPlus color="white" style={{width:'15px'}}  /></button>
        </div>
      </div>
    );
  };
  return (
    <div className={styles.mainDiv}>
      <div className={styles.heading}>
        <h1>Inventory</h1>
        <h2>Store Location</h2>
      </div>
      <div>
        <AntdDropdown
          placeholder={'Select Location'}
          name={"location"}
          label={"Location"}
          onChange={(val) => setselectedLocation(val)}
          options={
            previousData?.data?.locations?.map((item) => { return ({ value: item?.id, option: item?.address }) })
          }
        />
      </div>
      <div className={styles.subHeading}>
        Store Location
      </div>
      <List
        className={styles.list}
        style={{ width: "100%" }}
        //   grid={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }}
        dataSource={Inventory}
        //   footer={loadMore}
        renderItem={renderItem}
      />
      <div className={styles.btn}>
        <AntdSubmit
          onClick={() => onPressDone()}
          text={"Request"}
          buttonStyle={{
            margin: "15px 0px",
            height: "60px",
            width: "100%",
          }}
        />
      </div>
    </div>
  );
};

export default StoreInventory;
